// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chatsList_container__NiWKZ {
  z-index: 4;
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 330px !important;
  min-height: 654px;
  padding: 10px;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  border-radius: var(--Corner-radius, 4px);
  background: var(--website-white, #FFF);
  box-shadow: 0 0 8px 0 rgba(42, 98, 149, 0.25);
  overflow: scroll; }

.chatsList_chatsWrapper__HP4tS {
  width: 100%; }

.chatsList_addChatButton__zu\\+PL {
  width: calc(100% - 20px);
  height: 40px;
  position: sticky;
  left: 12px;
  bottom: 0; }
`, "",{"version":3,"sources":["webpack://./src/pages/aiChat/components/chatsList/chatsList.module.scss"],"names":[],"mappings":"AAGA;EACE,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,uBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,wCAAwC;EACxC,sCAAsC;EACtC,6CAA6C;EAC7C,gBAAgB,EAAA;;AAGlB;EACE,WAAW,EAAA;;AAGb;EACE,wBAAwB;EACxB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS,EAAA","sourcesContent":["@import '../../../../styles/common.scss';\n@import '../../../../styles/fonts';\n\n.container {\n  z-index: 4;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  width: 330px!important;\n  min-height: 654px;\n  padding: 10px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 20px;\n  border-radius: var(--Corner-radius, 4px);\n  background: var(--website-white, #FFF);\n  box-shadow: 0 0 8px 0 rgba(42, 98, 149, 0.25);\n  overflow: scroll;\n}\n\n.chatsWrapper {\n  width: 100%;\n}\n\n.addChatButton {\n  width: calc(100% - 20px);\n  height: 40px;\n  position: sticky;\n  left: 12px;\n  bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `chatsList_container__NiWKZ`,
	"chatsWrapper": `chatsList_chatsWrapper__HP4tS`,
	"addChatButton": `chatsList_addChatButton__zu+PL`
};
export default ___CSS_LOADER_EXPORT___;
